import { backend } from "declarations/backend";

document.getElementById('generateBtn').addEventListener('click', async () => {
    const namesText = document.getElementById('names').value.trim();
    if (!namesText) {
        alert('Please enter at least two names.');
        return;
    }

    const names = namesText.split('\n').map(name => name.trim()).filter(name => name);
    if (names.length < 2) {
        alert('Please enter at least two names.');
        return;
    }

    document.getElementById('loadingSpinner').classList.remove('d-none');
    try {
        const result = await backend.createAssignment(names);
        const resultSection = document.getElementById('resultSection');
        const codeDisplay = document.getElementById('codeDisplay');
        
        let html = '<h3 class="mb-3">Generated Codes:</h3>';
        html += '<div class="table-responsive"><table class="table">';
        html += '<thead><tr><th>Name</th><th>Code</th></tr></thead><tbody>';
        
        result.participantCodes.forEach(([name, code]) => {
            html += `<tr><td>${name}</td><td><code>${code}</code></td></tr>`;
        });
        
        html += '</tbody></table></div>';
        html += '<div class="alert alert-success mt-3">Share these codes with the participants!</div>';
        
        codeDisplay.innerHTML = html;
        resultSection.classList.remove('d-none');
    } catch (error) {
        alert('Error generating assignments. Please try again.');
    } finally {
        document.getElementById('loadingSpinner').classList.add('d-none');
    }
});

document.getElementById('checkBtn').addEventListener('click', async () => {
    const code = document.getElementById('codeInput').value.trim();
    if (!code) {
        alert('Please enter a code.');
        return;
    }

    document.getElementById('loadingSpinner').classList.remove('d-none');
    try {
        const result = await backend.getAssignment(code);
        const resultDiv = document.getElementById('assignmentResult');
        
        if ('Success' in result) {
            resultDiv.innerHTML = `
                <div class="alert alert-success">
                    You are Secret Santa for: <strong>${result.Success}</strong>
                </div>`;
        } else if ('AlreadyUsed' in result) {
            resultDiv.innerHTML = `
                <div class="alert alert-warning">
                    This code has already been used.
                </div>`;
        } else if ('InvalidCode' in result) {
            resultDiv.innerHTML = `
                <div class="alert alert-danger">
                    Invalid code. Please check and try again.
                </div>`;
        }
    } catch (error) {
        document.getElementById('assignmentResult').innerHTML = `
            <div class="alert alert-danger">
                Error checking assignment. Please try again.
            </div>`;
    } finally {
        document.getElementById('loadingSpinner').classList.add('d-none');
    }
});
